const opeLore = {
  "1": [
    "La línea 1 (Circular) tiene transbordo gratuito con el Tranvía y viceversa.",
    "Basa su recorrido en conectar el Anillo Interno de la ciudad en único sentido.",
    "Comparte gran parte de su trazado de manera inversa con la línea 8 (aunque con matices)."
  ],
  "2": [
    "La línea 2 (Periférica) era la arteria principal antes de la llegada del BEi.",
    "Ahora su recorrido y funciones las realiza principalmente el BEi.",
    "El BEi A es el equivalente a la Periférica en sentido antihorario."
  ],
  "3": [
    "La línea 3 conecta Betoño con Goikolarra.",
    "Es una de las líneas que más ha extendido su recorrido por el crecimiento del sur (Aretxabaleta/Goikolarra)."
  ],
  "4": [
    "Conecta Lakua con Mariturri.",
    "Tiene una de las mayores afluencias de viajeros, sirviendo como eje Norte-Suroeste."
  ],
  "5": [
    "Conecta Arkaiate con Elejalde.",
    "Es el eje principal Este-Oeste de la ciudad junto a la L6."
  ],
  "6": [
    "Conecta Zabalgana con Arkaiate.",
    "Junto con la L5, vertebra el corredor de Salburua y Zabalgana cruzando el centro."
  ],
  "7": [
    "Une Borinbizkarra con Paz.",
    "Atiende los nuevos sectores de Zabalgana norte."
  ],
  "8": [
    "La línea 8 (Unibertsitatea) recorre el anillo interno de manera inversa a la L1.",
    "Es vital para los estudiantes que acuden al Campus Sur."
  ],
  "9": [
    "Une Gamarra con Goikolarra.",
    "Es la línea que más se adentra en la zona Norte industrial (Polígono de Gamarra)."
  ],
  "10": [
    "Une Aldaia con Larrein.",
    "Una de las incorporaciones recientes para cubrir los nuevos sectores en los extremos del ensanche este y oeste."
  ],
  "A": [
    "BEi A (Bus Eléctrico Inteligente). Realiza el recorrido circular Periférico en sentido ANTIHORARIO.",
    "Tiene prioridad semafórica y andenes propios.",
    "Los billetes deben comprarse antes de subir al vehículo."
  ],
  "B": [
    "BEi B (Bus Eléctrico Inteligente). Realiza el recorrido circular Periférico en sentido HORARIO.",
    "Cruce estratégico con el Tranvía en Honduras y Euskal Herria."
  ]
};

export const getRandomLore = (lineId) => {
  // Limpiamos la ID por si viene como "L1" en vez de "1"
  const cleanId = lineId.replace('L', '').trim();
  const facts = opeLore[cleanId];
  if (!facts || facts.length === 0) {
    return `La línea ${lineId} es clave en la red de transportes de TUVISA. ¡No olvides repasar su recorrido!`;
  }
  const randomIdx = Math.floor(Math.random() * facts.length);
  return facts[randomIdx];
};
